<!-- ========================= header start ========================= -->
<header class="header bg-head navbar-area" #headerNavbar>
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <nav class="navbar navbar-expand-lg">
                    <a class="navbar-brand" href="javascript:void(0)">
                        <img src="assets/img/logo/logo.svg" alt="Logo" />
                    </a>
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="toggler-icon"></span>
                        <span class="toggler-icon"></span>
                        <span class="toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse sub-menu-bar" id="navbarSupportedContent">
                        <ul id="nav" class="navbar-nav ms-auto" #nav>
                            <li class="nav-item">
                                <a class="page-scroll active" href="https://www.sacombank.com.vn/canhan/Pages/default.aspx" data-bs-toggle="collapse" data-bs-target="#submenu-1-1" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">Cá nhân</a>
                            </li>
                            <li class="nav-item">
                                <a class="page-scroll" href="https://www.sacombank.com.vn/doanhnghiep/Pages/default.aspx">Doanh nghiệp</a>
                            </li>

                            <li class="nav-item">
                                <a class="page-scroll" href="https://www.sacombank.com.vn/Pages/default.aspx">Về SACOMBANK</a>
                            </li>
                        </ul>
                        <form action="#" class="search-form">
                            <a href="https://www.isacombank.com.vn/" class="btn-DigitalBank btn" style="text-transform: unset !important"><img src="assets/img/ico-mobile.svg" alt="ico" /> Internet Banking</a>
                        </form>
                    </div>
                    <!-- navbar collapse -->
                </nav>
                <!-- navbar -->
            </div>
        </div>
        <!-- row -->
    </div>
    <!-- container -->
</header>
<!-- ========================= header end ========================= -->